import { render, staticRenderFns } from "./DeleteBtn.vue?vue&type=template&id=426e1b87&scoped=true"
import script from "./DeleteBtn.vue?vue&type=script&lang=js"
export * from "./DeleteBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426e1b87",
  null
  
)

export default component.exports